export default __webpack_public_path__ + "static/media/airno.6c06a846.jpg";